import React, { useEffect, useState } from "react";
import "./style.scss";
import AuthFrame from "../../../components/Auth/AuthFrame";
import SignupForm from "../../../components/Auth/SignupForm";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { pushLead } from "../../../store/reducers/userProfileReducer";
import { ref } from "yup";
import { setTheme } from "../../../store/actions";

function Signup() {
  const { referalCode } = useParams();
  const dispatch = useDispatch();
  const { theme } = useSelector((state) => state.theme);

  useEffect(() => {
    if (referalCode) {
      dispatch(pushLead(referalCode));
    }
  }, [dispatch, referalCode]);

  useEffect(() => {
    document.body.classList["value"] === "" &&
      (document.body.classList = theme);
  }, [theme]);

  useEffect(() => {
    dispatch(setTheme("light"));
  }, []);
  return (
    <div className="signup-container">
      <div className="signup-left-wrapper">
        <div className="signup-left">
          <SignupForm referalCode={referalCode} />
        </div>
      </div>
      <div className="signup-right">
        <AuthFrame />
      </div>
    </div>
  );
}

export default Signup;
